import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <div data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-vault-black px-6 text-stone-900">
            <div className="w-full max-w-md border border-vault-border p-10 text-center">
                <XCircle size={44} className="mx-auto text-vault-red" />
                <h1 className="mt-6 font-display text-3xl uppercase">Payment Cancelled</h1>
                <p className="mt-6 text-sm leading-relaxed text-stone-600">
                    No charge was made. Your cart is still waiting for you in the Vault.
                </p>
                <Link
                    data-testid="cancel-back-to-shop-link"
                    to="/"
                    className="btn-sweep mt-10 inline-block border border-vault-red px-8 py-3 font-mono text-xs tracking-[0.25em] text-stone-900"
                >
                    BACK TO THE VAULT
                </Link>
            </div>
        </div>
    );
}
